var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFilledAlertInfoCustomFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0zm-1.091 11.579c0-.604.489-1.095 1.091-1.095s1.091.49 1.091 1.095v4.379c0 .604-.489 1.095-1.091 1.095s-1.091-.49-1.091-1.095v-4.38zM12 7.2c.602 0 1.091.49 1.091 1.095 0 .604-.489 1.094-1.091 1.094s-1.091-.49-1.091-1.094c0-.605.489-1.095 1.091-1.095z",
    transform: "translate(-311 -273) translate(311 273.5)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilledAlertInfoCustomFill);
export default __webpack_public_path__ + "static/media/icon-filled-alert-info-custom-fill.f1cf22d5040331661e9617e4def4d4f4.svg";
export { ForwardRef as ReactComponent };